import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { VirtualConnectionLineageSubplaceRouter, VirtualConnectionLineageSubplaceRouterProps } from './VirtualConnectionLineageSubplace';

export type EmbeddableVirtualConnectionSubplaceProps = VizPortalDataCatalogProviderProps & VirtualConnectionLineageSubplaceRouterProps;

export function EmbeddableVirtualConnectionSubplaceWithoutRouter(props: EmbeddableVirtualConnectionSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <VirtualConnectionLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
